// hooks/useHashScroll.ts
import { useEffect } from 'react'
import { useLocation } from 'react-router'

export function useHashScroll() {
	const location = useLocation()

	useEffect(() => {
		if (location.hash) {
			// Small delay to ensure content is rendered
			const timeoutId = setTimeout(() => {
				const element = document.getElementById(location.hash.slice(1))
				if (element) {
					element.scrollIntoView({
						behavior: 'smooth',
						block: 'start',
					})
				}
			}, 200)

			return () => clearTimeout(timeoutId)
		}
	}, [location.hash, location.pathname]) // Trigger on both hash and path changes
}
